<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <div style="min-height: 100vh">
            <navbar :navbar_sub_visible="$device != 'mobile'" />
            <div style="margin: 8px">
                <b-input-group>
                    <b-input-group-prepend>
                        <span class="input-group-text left">
                            <i class="fe fe-search"></i>
                        </span>
                    </b-input-group-prepend>
                    <b-form-input class="search-input black" size="lg" placeholder="ค้นหารายการสิทธิประโยชน์หรือกิจกรรม" v-model="keyword"> </b-form-input>
                    <b-input-group-prepend @click="keyword = ''">
                        <span class="input-group-text right">
                            <i class="fe fe-x"></i>
                        </span>
                    </b-input-group-prepend>
                </b-input-group>
            </div>
            <v-infinite-scroll :loading="getting_data" @bottom="nextPage" @top="prevPage" style="overflow-y: scroll; overflow-x: hidden">
                <div class="br-12 content" v-for="(data, index) in search_data" :key="'search_data_' + index" @click="onClickDetail(data)">
                    <!-- <div
                    :key="'search_data_' + index"
                    class="search-result"
                    style="margin: 8px"
                    @click="
                        $router.replace({
                            path: '/search-detail',
                            query: { data },
                        })
                    "
                >
                    <div style="background-color: #fff; padding: 8px; display: flex">
                        <div style="width: 33%">
                            <img
                                :src="data.image"
                                :style="{
                                    width: $device == 'mobile' ? '100%' : '50%',
                                    margin: '0',
                                    'vertical-align': 'unset',
                                }"
                            />
                        </div>
                        <div style="width: 66%; padding-left: 8px; vertical-align: top">
                            <label class="title">
                                {{ data.title }}
                            </label>
                        </div>
                    </div>
                </div> -->
                    <div class="row">
                        <div class="col-6">
                            <img :src="data.image" style="width: 100%; border-top-left-radius: 12px; border-bottom-left-radius: 12px" />
                        </div>
                        <div class="col-6 p-16">
                            <span class="fs-18 fw-600 description">
                                {{ data.title }}
                            </span>
                        </div>
                    </div>
                </div>
            </v-infinite-scroll>
            <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
        </div>
    </a-spin>
</template>
<script>
import navbar from '../../components/navbar';
export default {
    components: {
        navbar,
    },
    data: function () {
        return {
            keyword: '',
            getting_data: true,
            searching: false,
            display_search_result: false,
            search_data: [],
            current_page: 1,
            last_page: 0,
        };
    },
    mounted() {
        console.log('[src\\views\\search\\index.vue]');
        console.log('$mode -->', this.$mode);
        // for (let i = 0; i < 18; i++) {
        //     this.search_data.push({
        //         image_url: 'https://via.placeholder.com/720x480.png?text=Sample',
        //         title: this.randStr(20),
        //         detail: this.randStr(40),
        //         description: this.randStr(255),
        //         condition: this.randStr(100),
        //         branch: this.randStr(100),
        //         favorite: i == 1 || i == 2 || i == 5,
        //     });
        // }
        // this.getSearchData();
        this.getSearch();
    },
    // updated() {
    //     console.log('this.keyword.length -->', this.keyword.length);
    //     if (this.keyword.length > 2) {
    //         /* this.getSearchData(); */
    //     } else {
    //         /* this.searching = false;
    //   this.display_search_result = false; */
    //     }
    // },
    watch: {
        keyword(val) {
            if (val.length > 2 || val.length == 0) {
                this.getSearch();
            }
        },
    },
    methods: {
        getSearchData() {
            if (this.searching) return;
            this.searching = true;
            const self = this;
            setTimeout(() => {
                self.searching = false;
                self.display_search_result = true;
            }, 1000);
        },
        randStr(length = 12) {
            length = parseInt(length, 10);
            let consonants = 'bcdfghjlmnpqrstv';
            let vowels = 'aeiou';
            consonants = consonants.split('');
            vowels = vowels.split('');
            const rand = function (limit) {
                return Math.floor(Math.random() * limit);
            };
            let i;
            let word = '';
            for (i = 0; i < length / 2; i++) {
                const randConsonant = consonants[rand(consonants.length)];
                const randVowel = vowels[rand(vowels.length)];
                word += i === 0 ? randConsonant.toUpperCase() : randConsonant;
                word += i * 2 < length - 1 ? randVowel : '';
            }
            return word;
        },
        nextPage() {
            if (this.current_page < this.last_page) {
                ++this.current_page;
                this.getSearch();
            }
        },
        prevPage() {
            console.log();
            if (this.current_page > 1) {
                --this.current_page;
                this.getSearch(() => (this.getting_data = false));
            }
        },
        getSearch() {
            this.getting_data = true;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/search/all',
                    data: {
                        keyword: this.keyword,
                        page: this.current_page,
                        per_page: 20,
                    },
                    callback: (res) => {
                        if (res) {
                            this.last_page = res.last_page;
                            this.search_data = res.data;
                            console.log('this.search_data', this.search_data);
                        }
                        this.getting_data = false;
                    },
                },
            });
        },
        onClickDetail(data) {
            var param = {
                back_path: '/search',
            };
            var route_name = '';
            if (data.type == 'news') {
                param.inbox_id = data.xid;
                route_name = '/inbox-detail';
            } else if (data.type == 'delight') {
                param.delight_id = data.xid;
                route_name = '/delight-detail';
            } else if (data.type == 'privilege') {
                param.priv_id = data.xid;
                route_name = '/privilege-detail';
            } else if (data.type == 'activity') {
                param.act_id = data.xid;
                route_name = '/activity-detail';
            } else if (data.type == 'reward') {
                param.priv_id = data.xid;
                route_name = '/reward-condition';
            }
            return this.r(route_name, param);
        },
    },
};
</script>
<style scope>
.content {
    margin: 16px 16px 0 16px;
    background-color: #ffffff;
}
.description {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
}
.input-group-text {
    background-color: #fff;
    padding: 8px;
    border: none;
}
.input-group-text.left {
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
}
.input-group-text.right {
    border-top-right-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
}
[class^='fe-'],
[class*=' fe-'] {
    display: inline-block;
    width: 100%;
    font-size: 20px;
}
.search-input {
    border-left: none;
    font-size: 16px;
    font-weight: 300;
    margin: 0;
    padding: 8px 0;
    border: none;
}
.search-input::-webkit-input-placeholder {
    font-size: 16px;
    color: #707070 !important;
    opacity: 0.5;
}
.search-input::-moz-placeholder {
    font-size: 16px;
    color: #707070 !important;
    opacity: 0.5;
}
.search-input:-moz-placeholder {
    font-size: 16px;
    color: #707070 !important;
    opacity: 0.5;
}
.search-input:-ms-input-placeholder {
    font-size: 16px;
    color: #707070 !important;
    opacity: 0.5;
}
.search-result {
    background-color: #fff;
}
.title {
    font-size: 20px;
    font-weight: 600;
    vertical-align: top;
    margin: 0;
    word-break: break-all;
}
@media (max-device-width: 413px) {
    [class^='fe-'],
    [class*=' fe-'],
    .title {
        font-size: 19px;
    }
    .search-input {
        font-size: 15px;
    }
    .search-input::-webkit-input-placeholder {
        font-size: 15px;
    }
    .search-input::-moz-placeholder {
        font-size: 15px;
    }
    .search-input:-moz-placeholder {
        font-size: 15px;
    }
    .search-input:-ms-input-placeholder {
        font-size: 15px;
    }
}
@media (max-device-width: 374px) {
    [class^='fe-'],
    [class*=' fe-'],
    .title {
        font-size: 17px;
    }
    .search-input {
        font-size: 13px;
    }
    .search-input::-webkit-input-placeholder {
        font-size: 13px;
    }
    .search-input::-moz-placeholder {
        font-size: 13px;
    }
    .search-input:-moz-placeholder {
        font-size: 13px;
    }
    .search-input:-ms-input-placeholder {
        font-size: 13px;
    }
}
</style>